import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { useSettingsRAP } from '~/composables/settings/roles-and-permissions';
import {
  AccessEntries,
  type TAccess,
  type TLinks,
  type TVisibility,
} from '~/composables/settings/roles-and-permissions/AccessEntries';
import { EXCEPTION_SUBMENU_BASED_ON_PERMISSION } from '~/composables/settings/roles-and-permissions/role-service';
import { useSettingsUser } from '~/composables/settings/user';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const publicPaths = [
    '',
    'auth/login',
    'login',
    'auth/forgot-password',
    'set-password',
  ];
  try {
    let toPath = to.path.replace(/^\/|\/$/g, '');
    const isShortLink = /^[a-zA-Z0-9]{6}$/.test(toPath);
    if (publicPaths.includes(toPath) || isShortLink) {
      return;
    }

    // NOTE: This file must be imported dynamically because it uses a Pinia store.
    // If imported statically, it runs before Pinia is initialized in the app,
    // causing a "Pinia not initialized" error.
    const sidebarData =
      await import('~/components/lc/Full/vertical-sidebar/sidebarItem');

    // let mapV2 = new Map(); TODO: Maybe it is better to have the
    // userAccess list as a map too

    const toPathV2 = to.path as TLinks;
    let ownerAccTypeList: TVisibility[] | undefined;
    let userAccTypeList: TAccess[] | undefined;
    let hasAccess: boolean | undefined;

    // 1. EXACT MATCH -> with the url
    if (AccessEntries.has(toPathV2)) {
      if (useSettingsUser.isOwner)
        ownerAccTypeList = AccessEntries.get(toPathV2)?.owner;
      else userAccTypeList = AccessEntries.get(toPathV2)?.user;
    }
    // 2. CONTAIN MATCH -> if no exact match, fall back to longest prefix
    else {
      const accessTuple = [...AccessEntries.entries()]
        .filter(([key]) => toPathV2.startsWith(key))
        .sort((a, b) => b[0].length - a[0].length)[0];

      if (useSettingsUser.isOwner) ownerAccTypeList = accessTuple[1].owner;
      else userAccTypeList = accessTuple[1].user;
    }

    // 1. Check the owner access
    if (
      useSettingsUser.isOwner &&
      useSettingsRAP.visibilityList &&
      ownerAccTypeList
    )
      hasAccess = [...Object.keys(useSettingsRAP.visibilityList)].some(
        (visAcc) =>
          ownerAccTypeList.includes(
            visAcc as keyof typeof useSettingsRAP.visibilityList
          ) || ownerAccTypeList.includes('open_to_all')
      );
    // 2. Check the user access
    else if (userAccTypeList) {
      hasAccess = useSettingsRAP.userAccess?.list.some((acc) => {
        const exception = EXCEPTION_SUBMENU_BASED_ON_PERMISSION?.[acc.access];
        if (!exception) {
          return (
            userAccTypeList.includes(acc.access) ||
            userAccTypeList.includes('open_to_all')
          );
        } else {
          return exception.some((item) => {
            return (
              toPathV2.includes(item.link) &&
              item.permissions.includes(acc.permission)
            );
          });
        }
      });
    }

    if (hasAccess) return;
    // END OF V2 PERMISSION CHECK < -----------------------

    return navigateTo('/');
  } catch (error) {
    return navigateTo('/');
  }
});
